import React, { useState, useEffect } from "react";
import { useTheme } from "../../context/ThemeContext";
import "./Record.css";
import { FaSearch } from "react-icons/fa";
import Loader from "../../components/LoaderModal";
import { getQuizList } from "../../api/api";
import { FaCopy } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';

const Record = () => {
    const { themeStyles, theme } = useTheme();
    const navigate = useNavigate();

    const [quizzes, setQuizzes] = useState([]); // Store quiz list
    const [loading, setLoading] = useState(false); // Loading state
    const [error, setError] = useState(null); // Error state
    const [search, setSearch] = useState(''); // Search term
    const [pagination, setPagination] = useState({
        totalQuizzes: 0,
        totalPages: 0,
        page: 1,
        limit: 10,
    }); // Pagination state
    const [debouncedSearch, setDebouncedSearch] = useState(''); // Debounced search term

    // const [quizzes, setQuizzes] = useState([]);
    // const [isLoading, setIsLoading] = useState(false); // Loading state

    const copyText = (text) => {
        console.log("Copying text:", text);
        navigator.clipboard.writeText(text)
            .then(() => {
                // setCopySuccess('Text copied!');
            })
            .catch(() => {
                // setCopySuccess('Failed to copy text');
            });
    };




    // Debounce search functionality
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500); // Debounce delay (500ms)

        // Cleanup timeout on every render
        return () => clearTimeout(timer);
    }, [search]); // Run effect whenever search term changes

    // Fetch quizzes with pagination and debounced search term
    const fetchQuizzes = async () => {
        setLoading(true);
        try {
            const data = await getQuizList({
                page: pagination.page,
                limit: pagination.limit,
                search: debouncedSearch,
            });

            setQuizzes(data.quizzes);
            setPagination((prevState) => ({
                ...prevState,
                totalQuizzes: data.pagination.totalQuizzes,
                totalPages: data.pagination.totalPages,
            }));
        } catch (err) {
            setError('Error fetching quizzes');
        } finally {
            setLoading(false);
        }
    };

    // Use effect to load quizzes when page, limit or debounced search term changes
    useEffect(() => {
        fetchQuizzes();
    }, [pagination.page, pagination.limit, debouncedSearch]);

    // Handle page change (previous or next)
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setPagination((prevState) => ({
                ...prevState,
                page: newPage,
            }));
        }
    };

    const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1) + " View";


    return (
        <div
            className="quiz-page h-full w-full flex flex-col overflow-auto no-scrollbar"
            style={{
                color: themeStyles.text,
                padding: 0,
                margin: 0,
            }}
        >
            {true && (
                <div>
                    {loading && <Loader />}
                    <div className="p-5 px-7">
                        {/* First Row */}
                        <div className="flex flex-wrap md:flex-nowrap items-center gap-3">
                            {/* Left Section */}
                            <div className="flex flex-wrap md:flex-nowrap items-center space-x-3 gap-2">
                                <span className="font-medium" style={{ color: themeStyles.text }}>
                                    Show
                                </span>
                                <select
                                    className="py-2 px-3 border rounded-md focus:outline-none focus:ring-2"
                                    style={{
                                        backgroundColor: themeStyles.cardBackground,
                                        color: themeStyles.text,
                                        borderColor: themeStyles.text,
                                    }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                                <span className="font-medium" style={{ color: themeStyles.text }}>
                                    entries
                                </span>
                            </div>

                            {/* Search Bar */}
                            <div
                                className="flex items-center p-2 rounded-lg border w-full md:w-auto"
                                style={{
                                    backgroundColor: themeStyles.cardBackground,
                                    borderColor: themeStyles.text,
                                }}
                            >
                                <FaSearch className="text-gray-400 mr-2" />
                                <input
                                    type="text"
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search..."
                                    className="w-full focus:outline-none bg-transparent"
                                    style={{ color: themeStyles.text }}
                                />
                            </div>

                            {/* Add New Quiz Button */}
                            <button
                                onClick={() => navigate("/question-creator")}
                                className="flex items-center px-4 py-2 rounded-md transition duration-200 whitespace-nowrap"
                                style={{
                                    backgroundColor: themeStyles.primaryColor,
                                    color: themeStyles.cardContentBackground,
                                    marginLeft: 'auto'
                                }}
                            >
                                <p className="text-white">+</p>
                                <p className="ml-2 text-white">Add New Quiz</p>
                            </button>
                        </div>
                    </div>


                    {/* Quiz Data Table */}
                    <div className="w-full overflow-x-auto overflow-y-auto max-h-[550px]">
                        <table
                            className="quiz-table w-full min-w-[900px] border-collapse"
                            style={{
                                color: themeStyles.text,
                            }}
                        >
                            <thead>
                                <tr>
                                    <th className="text-center px-4 py-2">Number</th>
                                    <th className="px-4 py-2">Quiz Name</th>
                                    <th className="px-4 py-2">Assigned Batch</th>
                                    <th className="px-4 py-2">Quiz Type</th>
                                    <th className="px-4 py-2">Total Marks</th>
                                    <th className="px-4 py-2">Time Limit</th>
                                    {/* <th className="px-4 py-2">Description</th> */}
                                    <th className="px-4 py-2">End Date</th>
                                    <th className="px-4 py-2">Link</th>

                                </tr>
                            </thead>
                            <tbody>
                                {!loading && quizzes.length === 0 && (
                                    <tr className="border-b">
                                        <td colSpan="8" className="text-center py-4 justify-center align-middle" style={{ color: themeStyles.text }}>

                                            No quizzes available
                                        </td>
                                    </tr>
                                )}
                                {quizzes.map((item, index) => (
                                    <tr
                                        key={index}
                                        className="border-b"
                                    >
                                        <td className="text-center px-4 py-2">{index + 1}</td>
                                        <td className="px-4 py-2">{item.name}</td>
                                        <td className="px-4 py-2">{item.batch.join(", ")}</td>
                                        <td className="px-4 py-2">{capitalizeFirstLetter(item.quizType)}</td>
                                        <td className="px-4 py-2">{item.totalMarks}</td>
                                        <td className="px-4 py-2">{item.timeLimit}</td>
                                        {/* <td className="px-4 py-2">{item.description}</td> */}
                                        <td className="px-4 py-2">{new Date("2025-02-08T00:00:00.000Z").toLocaleDateString("en-GB")}</td>
                                        <td className="px-4 py-2 flex items-center space-x-2">
                                            <button onClick={() => copyText(window.location.origin + "/quiz/" + item._id)}>
                                                <FaCopy size={20} className="text-blue-500" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>



                    {/* Pagination */}
                    {!loading && quizzes.length != 0 && (
                        <div className="flex items-center justify-center space-x-2 m-10">
                            {/* Previous Button */}
                            <button
                                className="px-4 py-2 text-sm font-medium hover:underline"
                                style={{ color: theme === "light" ? themeStyles.primaryColor : "#FFF" }}
                                onClick={() => handlePageChange(pagination.page - 1)}
                                disabled={pagination.page <= 1}
                            >
                                Previous
                            </button>

                            {/* Page Numbers */}
                            {pagination.totalPages > 0 && Array.from({ length: pagination.totalPages }, (_, index) => index + 1).map((number) => (
                                <button
                                    key={number}
                                    className="px-4 py-2 text-sm font-medium rounded-md"
                                    style={{
                                        backgroundColor: themeStyles.primaryColor,
                                        color: "#fff",
                                    }}
                                >
                                    {number}
                                </button>
                            ))}

                            {/* Next Button */}
                            <button
                                className="px-4 py-2 text-sm font-medium hover:underline"
                                onClick={() => handlePageChange(pagination.page + 1)}
                                disabled={pagination.page >= pagination.totalPages}
                                style={{ color: theme === "light" ? themeStyles.primaryColor : "#FFF" }}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>

    );
};

export default Record;
